// extracted by mini-css-extract-plugin
module.exports = {"form":"style-module--form--3J6V3"};